import { focusAtom } from 'jotai-optics';
import { surveyAtom } from './surveyAtom';

export const completedAtom = focusAtom(surveyAtom, (optic) =>
  optic.optional().prop('completed')
);
